import { ROLES } from 'globalconfig/constants/keys';

export const roleMap = {
  mechanicRole: ROLES.MECHANIC,
  driverRole: ROLES.DRIVER,
  adminRole: ROLES.ADMIN,
  fleetManagerRole: ROLES.FLMANAGER,
  fleetManagerRoleDefault: ROLES.OWNER,
  serviceManagerRole: ROLES.SERVICE_MANAGER,
  underWriterRole: ROLES.UNDER_WRITER,
  lossControlRole: ROLES.LOSS_CONTROL,
  claimAdjusterRole: ROLES.CLAIM_ADJUSTER,
};
